export default {
    topics: [
        {
            title: ' monitoring ',
            href: 's-nl-monitoring.html',
            attributes: { 'data-id': 's-nl-monitoring' },
            menu: { hasChildren: false },
            tocID: 's-nl-monitoring-d66e1940',
            next: 's-nl-monitoring-d66e1940',
        },
    ],
};

